function Header() {
  return (
    <header className="app-header">
      <h1>Find your profession</h1>
    </header>
  );
}

export default Header;
